import { createAction, props } from '@ngrx/store';
import { UIGeneration, UIGenerationStep } from '../../reducers/generations/generation.reducer';

const GET_ALL_GENERATIONS = '[Generations] Get All Generations';
const SET_CURRENT_STEP_OF_GENERATION = '[Generations] Set Current Step Of Generation';
const CREATE_NEW_GENERATION = '[Generations] Create New Generation';
const UPDATE_GENERATION_API = '[Generations] Update Generation API';
const GET_GENERATION_BY_ID = '[Generations] Get Generation By Id';
const COMPLETE_GENERATION = '[Generations] Complete Generation';
const CREATE_GENERATION_FAILURE = '[Generations] Create Generation Failure';
const UPDATE_GENERATION_FAILURE = '[Generations] Update Generation Failure';
const SET_GENERATIONS = '[Generations] Set Generations';
const ADD_GENERATION = '[Generations] Add Generation';
const UPDATE_GENERATION = '[Generations] Update Generation';
const SET_CURRENT_GENERATION = '[Generations] Set Current Generation';
const SET_CURRENT_GENERATION_STEPS = '[Generations] Set Current Generation Steps';
const UPDATE_STEP_READ_ONLY_STATUS = '[Generations] Update Step ReadOnly Status';
const UPDATE_PRIOR_STEPS_READ_ONLY_STATUS = '[Generations] Update Prior Steps ReadOnly Status';
const UPDATE_ALL_STEPS_READ_ONLY_STATUS = '[Generations] Update All Steps ReadOnly Status';
const UPDATE_STEP_AI_GENERATING_STATUS = '[Generations] Update Step AI Generating Status';
const UPDATE_STEP = '[Generations] Update Step';
const RESET_GENERATION = '[Generations] Reset Generation';
const CREATE_GENERATION_SUCCESS = '[Generations] Create Generation Success';
const COMPLETE_GENERATION_SUCCESS = '[Generations] Complete Generation Success';
const COMPLETE_GENERATION_FAILURE = '[Generations] Complete Generation Failure';
const SET_UNDER_MANUAL_NAVIGATION_CONTROL = '[Generations] Set Under Manual Navigation Control';

const getAllGenerations = createAction(GET_ALL_GENERATIONS, props<{ apiConstants: any; filter?: any }>());
const setCurrentStepOfGeneration = createAction(SET_CURRENT_STEP_OF_GENERATION, props<{ currentStep: any }>());
const createGeneration = createAction(CREATE_NEW_GENERATION, props<{ apiConstants: any; data: any }>());
const updateGenerationAPI = createAction(UPDATE_GENERATION_API, props<{ apiConstants: any; data: any }>());
const getGenerationById = createAction(
  GET_GENERATION_BY_ID,
  props<{ apiConstants: any; urlPathVariables: { generationId: string } }>()
);
const completeGeneration = createAction(
  COMPLETE_GENERATION,
  props<{ apiConstants: any; urlPathVariables: { generationId: string; removeUrlVariables: string[] } }>()
);

const createGenerationFailure = createAction(CREATE_GENERATION_FAILURE, props<{ error: any }>());
const updateGenerationFailure = createAction(UPDATE_GENERATION_FAILURE, props<{ error: any }>());

const setGenerations = createAction(SET_GENERATIONS, props<{ generations: UIGeneration[] }>());

const addGeneration = createAction(ADD_GENERATION, props<{ generation: UIGeneration }>());

const updateGeneration = createAction(
  UPDATE_GENERATION,
  props<{ generation: Partial<UIGeneration> & { id: string } }>()
);

const setCurrentGeneration = createAction(SET_CURRENT_GENERATION, props<{ generationId: string }>());

const setCurrentGenerationSteps = createAction(
  SET_CURRENT_GENERATION_STEPS,
  props<{ generationId: string; steps: UIGenerationStep[] }>()
);

const updateStepReadOnlyStatus = createAction(
  UPDATE_STEP_READ_ONLY_STATUS,
  props<{ stepKey: string; readOnly: boolean }>()
);

const updatePriorStepsReadOnlyStatus = createAction(
  UPDATE_PRIOR_STEPS_READ_ONLY_STATUS,
  props<{ currentGenerationId: string; stepKey: string; readOnly: boolean }>()
);

const updateAllStepsReadOnlyStatus = createAction(
  UPDATE_ALL_STEPS_READ_ONLY_STATUS,
  props<{ currentGenerationId: string; readOnly: boolean }>()
);

const updateStepAiGeneratingStatus = createAction(
  UPDATE_STEP_AI_GENERATING_STATUS,
  props<{ stepKey: string; aiGenerating: boolean }>()
);

const updateStep = createAction(UPDATE_STEP, props<{ stepKey: string; changes: Partial<UIGenerationStep> }>());

const resetGeneration = createAction(RESET_GENERATION);

const createGenerationSuccess = createAction(CREATE_GENERATION_SUCCESS, props<{ generation: UIGeneration }>());

const completeGenerationSuccess = createAction(COMPLETE_GENERATION_SUCCESS);
const completeGenerationFailure = createAction(COMPLETE_GENERATION_FAILURE);

const setUnderManualNavigationControl = createAction(SET_UNDER_MANUAL_NAVIGATION_CONTROL, props<{ value: boolean }>());

export const GenerationActions = {
  getAllGenerations,
  setGenerations,
  createGeneration,
  updateGeneration,
  setCurrentGeneration,
  setCurrentStepOfGeneration,
  resetGeneration,
  setCurrentGenerationSteps,
  getGenerationById,
  completeGeneration,
  createGenerationFailure,
  updateGenerationFailure,
  addGeneration,
  updateStepReadOnlyStatus,
  updatePriorStepsReadOnlyStatus,
  updateAllStepsReadOnlyStatus,
  updateStepAiGeneratingStatus,
  updateStep,
  updateGenerationAPI,
  createGenerationSuccess,
  completeGenerationSuccess,
  completeGenerationFailure,
  setUnderManualNavigationControl
};
